var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _rect5, _rect6, _path71, _rect7, _rect8, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _rect9, _rect10, _path84, _path85;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassKeySetUpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.0387,
    y: 24.9508,
    width: 98.9225,
    height: 98.9225,
    rx: 49.4613,
    fill: "#212327"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0387,
    y: 24.9508,
    width: 98.9225,
    height: 98.9225,
    rx: 49.4613,
    stroke: "#0B0B0B",
    strokeWidth: 1.07746
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3691 45.4181C47.9876 45.4954 47.1529 45.7996 46.5144 46.0939C45.8757 46.3885 45.2568 46.6483 45.1391 46.6714C44.8926 46.72 43.9705 47.475 43.2775 48.1952C43.0163 48.4669 42.4721 49.3509 42.0682 50.1598C41.3544 51.59 41.334 51.6914 41.334 53.8197C41.334 56.1571 41.4747 56.6741 42.6691 58.7283C42.9737 59.2522 43.1631 59.7771 43.09 59.8949C43.0171 60.0126 43.0399 60.058 43.1409 59.9958C43.3046 59.895 46.2849 64.8943 46.1464 65.037C46.1155 65.0686 46.2685 65.289 46.4865 65.5269C46.7045 65.7645 47.1949 66.5624 47.5764 67.3C47.9579 68.0377 48.3499 68.6988 48.4476 68.7694C48.5451 68.8399 48.5685 69.0446 48.4993 69.2241C48.4293 69.4061 48.4559 69.4999 48.5595 69.4361C48.7765 69.3025 49.2082 70.0106 49.0227 70.1957C48.9539 70.2642 48.9927 70.3203 49.1093 70.3203C49.3608 70.3203 50.1526 71.603 50.1526 72.0107C50.1526 72.1676 50.2216 72.2958 50.3058 72.2958C50.3901 72.2958 50.6334 72.6292 50.8468 73.0366C51.0601 73.4441 51.5708 74.3344 51.9818 75.0156C52.3926 75.6965 52.7289 76.2984 52.7289 76.3531C52.7289 76.4079 52.9463 76.7842 53.2122 77.1892C53.478 77.5943 53.7233 78.0591 53.7572 78.2221C53.7911 78.3851 53.8729 78.5629 53.9389 78.6172C54.1052 78.7541 55.5376 81.1341 55.9599 81.9755C56.1507 82.3558 56.3911 82.8002 56.494 82.9632C56.9924 83.7528 58.2777 85.9412 58.2777 86.0003C58.2777 86.0372 58.7361 86.8578 59.2963 87.8242C59.8566 88.7904 60.5127 89.9366 60.7547 90.3712C60.9966 90.8058 61.6157 91.8911 62.1308 92.7832C62.6458 93.6751 63.0085 94.4997 62.9367 94.6154C62.865 94.731 62.9072 94.8013 63.0305 94.7715C63.1537 94.7416 63.4805 95.1172 63.7564 95.6061C64.0322 96.095 64.3838 96.692 64.5378 96.9326C64.6916 97.1732 64.8174 97.5065 64.8174 97.6734C64.8174 97.8401 64.8877 97.9766 64.9739 97.9766C65.06 97.9766 65.4834 98.6068 65.9153 99.3772C66.3469 100.147 66.9131 101.155 67.1737 101.617C67.4341 102.078 67.896 102.622 68.2 102.826C68.504 103.029 68.7206 103.248 68.6814 103.311C68.5892 103.46 69.6213 103.591 70.7881 103.579C71.9044 103.567 72.7421 103.028 73.3667 101.92C73.6095 101.49 73.8808 101.137 73.9698 101.137C74.0588 101.137 74.117 101.071 74.0996 100.989C74.0639 100.824 74.4186 100.014 74.7264 99.557C74.8362 99.394 75.5355 98.2167 76.2807 96.9409C77.0256 95.665 77.7083 94.6871 77.7977 94.7679C77.8873 94.8485 77.891 94.7952 77.8062 94.649C77.7129 94.4884 77.8179 94.1597 78.0716 93.8173C78.3024 93.5062 78.4913 93.2127 78.4913 93.165C78.4913 93.1174 78.8561 92.4796 79.3022 91.7478C80.2734 90.1543 80.7449 89.339 81.513 87.9248C82.5389 86.0358 83.1691 85.1244 83.3412 85.2802C83.4335 85.364 83.4446 85.3207 83.3657 85.1842C83.2865 85.0471 83.4054 84.6797 83.6313 84.3636C83.8562 84.0487 84.0401 83.7479 84.0401 83.6951C84.0401 83.6424 84.8427 82.2511 85.8237 80.6035C86.8046 78.956 87.6072 77.5406 87.6072 77.4584C87.6072 77.3762 87.7683 77.1366 87.9651 76.926C88.1619 76.7152 88.3448 76.4541 88.3714 76.3454C88.5138 75.7621 91.5243 70.9301 91.6654 71.0579C91.7571 71.1411 91.7772 71.1127 91.7098 70.9945C91.6424 70.8764 91.9402 70.1777 92.3717 69.4416C92.8031 68.7056 93.156 68.072 93.156 68.0335C93.156 67.9952 93.6465 67.1574 94.246 66.1719C94.8454 65.1863 95.3359 64.3457 95.3359 64.3039C95.3359 64.262 95.7818 63.5111 96.3268 62.6352C96.8718 61.7593 97.3176 61.0049 97.3176 60.959C97.3176 60.913 97.7635 60.1201 98.3085 59.1971C98.8535 58.274 99.2994 57.3716 99.2994 57.1914C99.2994 57.0113 99.3695 56.9072 99.4553 56.9599C99.5411 57.0129 99.6317 56.0625 99.6569 54.848C99.6965 52.926 99.6388 52.463 99.2112 51.2736C98.9411 50.5219 98.6406 49.8552 98.5439 49.792C98.447 49.7286 98.2552 49.4641 98.1177 49.2039C97.5862 48.1986 96.2192 46.9675 95.0072 46.4025C92.3796 45.1781 93.4967 45.2299 70.2751 45.2548C58.6083 45.2672 48.7506 45.3407 48.3691 45.4181ZM67.1955 69.7241C67.1955 79.7219 67.1594 87.9018 67.1152 87.9018C67.0221 87.9018 65.1285 84.715 65.0907 84.4942C65.0766 84.4126 65.0433 84.2794 65.017 84.1979C64.9904 84.1163 64.9815 83.9764 64.9969 83.8869C65.0126 83.7972 64.9474 83.772 64.8521 83.8308C64.757 83.8895 64.555 83.6961 64.4034 83.401C64.2518 83.1058 63.8693 82.42 63.5535 81.8767C61.451 78.2618 59.4667 74.804 59.4667 74.7552C59.4667 74.7236 59.0177 73.9759 58.469 73.0938C57.9129 72.2001 57.5322 71.3843 57.6089 71.2509C57.6848 71.1194 57.6735 71.0779 57.5841 71.1587C57.4945 71.2395 57.3241 71.1344 57.2054 70.925C56.5148 69.7067 55.141 67.321 53.957 65.2829C53.5152 64.5223 53.125 63.7671 53.09 63.6046C53.0549 63.442 52.9183 63.2197 52.7866 63.1107C52.655 63.0016 52.0416 62.0234 51.4237 60.9369C50.8058 59.8504 50.1376 58.6948 49.9386 58.3688C48.8041 56.5097 47.5764 54.1167 47.5764 53.7642C47.5764 53.0248 47.9313 52.4087 48.6006 51.9859C49.2466 51.5778 49.4541 51.5685 58.2282 51.5576L67.1955 51.5464V69.7241ZM92.3786 52.526C92.8659 53.0118 92.9579 53.2619 92.9579 54.1016C92.9579 55.0425 92.3891 56.4518 92.1182 56.182C92.0568 56.1207 92.0201 56.1899 92.0364 56.3355C92.077 56.697 88.1441 63.394 87.9584 63.2796C87.8767 63.2292 87.8553 63.3063 87.911 63.4507C87.9665 63.5951 87.7871 64.0168 87.5123 64.3882C87.2376 64.7596 87.0127 65.1249 87.0127 65.2003C87.0127 65.4957 84.892 68.9327 84.7674 68.8393C84.6943 68.7846 84.6756 68.7956 84.726 68.864C84.7761 68.9322 84.6085 69.3543 84.3534 69.8023C83.7389 70.8807 82.0962 73.6995 81.864 74.0737C81.7629 74.2366 80.993 75.5701 80.1532 77.0368C77.1185 82.337 76.2589 83.7534 76.077 83.7534C75.9751 83.7534 75.9327 83.82 75.983 83.9015C76.0334 83.9831 75.8607 84.4053 75.5998 84.8399C75.3386 85.2745 75.0627 85.7634 74.9864 85.9264C74.9101 86.0894 74.553 86.7116 74.1929 87.3092L73.538 88.3957L73.5376 70.1721L73.537 51.9486H82.6682H91.7993L92.3786 52.526Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0387,
    y: 16.1266,
    width: 98.9225,
    height: 98.9225,
    rx: 49.4613,
    fill: "#373C44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0387,
    y: 16.1266,
    width: 98.9225,
    height: 98.9225,
    rx: 49.4613,
    stroke: "#0B0B0B",
    strokeWidth: 1.07746
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7295 120.025L34.6816 120.906",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2041 38.7033C52.0611 38.7033 52.5138 38.2035 53.9182 39.156C56.1565 40.6317 56.9183 43.537 56.9183 45.394C56.9183 49.1081 53.6091 53.6798 49.9899 53.6798C46.3951 53.6798 43.7997 49.5373 43.5142 45.9417V45.9181C43.5142 45.7518 43.5142 45.5612 43.5142 45.394C43.5142 41.7026 46.5135 38.7033 50.2041 38.7033ZM46.7991 56.1306C48.6796 58.0112 51.7512 58.0112 53.6083 56.1306L54.8698 54.8926H55.7265C58.0363 54.8926 58.6074 54.345 59.9404 55.3689C61.7025 56.7018 62.1073 59.0116 62.1073 60.6544V67.6542H56.9167H43.6318H38.3227L37.2988 66.1306L38.3227 60.6544C39.061 56.7497 40.7273 54.8926 44.7035 54.8926H45.5602L46.7991 56.1306Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.084 66.1309L62.1078 67.6545",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8945 66.1309L56.9184 67.6545",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2988 66.1309L38.3227 67.6545",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6805 53.3691H44.5372L45.7752 54.6307C47.6558 56.5112 50.7273 56.5112 52.5844 54.6307L53.846 53.3691H54.7027C58.6788 53.3691 61.0835 55.1783 61.0835 59.1545V66.1299H37.2988V59.1545C37.2997 55.1783 39.7043 53.3691 43.6805 53.3691Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1801 37.1777C45.4896 37.1777 42.4902 40.1779 42.4902 43.892C42.4902 47.5826 45.4904 52.3919 49.1801 52.3919C52.8942 52.3919 55.8944 47.5826 55.8944 43.892C55.8944 40.1779 52.8942 37.1777 49.1801 37.1777Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4902 44.4172C46.4899 44.298 49.1801 43.9889 51.9896 41.2272C51.9896 41.2272 53.0135 43.1792 55.8944 43.8939C55.8944 40.1798 52.8942 37.1797 49.1801 37.1797C45.4896 37.1797 42.4902 40.1798 42.4902 43.8939C42.4902 44.0602 42.4902 44.2501 42.4902 44.4172Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8945 66.131V59.6074",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8945 43.8926C55.8945 43.8926 56.8235 45.4405 56.7756 46.8214",
    stroke: "black",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8943 43.8922C55.8943 43.8922 56.8232 45.4402 56.7753 46.821C56.8703 46.3448 56.9181 45.8686 56.9181 45.3923C56.9181 43.5353 56.1563 40.6309 53.918 39.1543C55.1325 40.3688 55.8943 42.0352 55.8943 43.8922Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3242 66.131V59.6074",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3242 66.1309L43.3716 67.6545",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0127 38.7033C92.8462 38.7033 93.2981 38.2035 94.7268 39.156C96.9408 40.6317 97.7269 43.537 97.7269 45.394C97.7269 49.1081 94.4177 53.6798 90.7985 53.6798C87.1793 53.6798 84.5848 49.5373 84.3228 45.9417V45.9181C84.2993 45.7518 84.2993 45.5612 84.2993 45.394C84.2984 41.7026 87.2986 38.7033 91.0127 38.7033ZM87.6077 56.1306C89.4882 58.0112 92.5363 58.0112 94.4168 56.1306L95.6549 54.8926H96.5116C98.8214 54.8926 99.3925 54.345 100.75 55.3689C102.512 56.7018 102.892 59.0116 102.892 60.6544V67.6542H97.7017H84.4168H79.1313L78.1074 66.1306L79.1313 60.6544C79.8452 56.7497 81.5359 54.8926 85.5121 54.8926H86.3453L87.6077 56.1306Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.869 66.1309L102.893 67.6545",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6777 66.1309L97.7016 67.6545",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1074 66.1309L79.1313 67.6545",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4891 53.3691H85.3223L86.5838 54.6307C88.4644 56.5112 91.5124 56.5112 93.393 54.6307L94.631 53.3691H95.4877C99.4639 53.3691 101.869 55.1783 101.869 59.1545V66.1299H78.1074V59.1545C78.1083 55.1783 80.4894 53.3691 84.4891 53.3691Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9877 37.1777C86.2736 37.1777 83.2734 40.1779 83.2734 43.892C83.2734 47.5826 86.2736 52.3919 89.9877 52.3919C93.6783 52.3919 96.6776 47.5826 96.6776 43.892C96.6776 40.1779 93.6783 37.1777 89.9877 37.1777Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2978 44.4172C87.2739 44.298 89.9642 43.9889 92.7972 41.2272C92.7972 41.2272 93.7975 43.1792 96.6776 43.8939C96.6776 40.1798 93.6774 37.1797 89.9877 37.1797C86.2736 37.1797 83.2734 40.1798 83.2734 43.8939C83.2743 44.0602 83.2743 44.2501 83.2978 44.4172Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6777 66.131V59.6074",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6777 43.8926C96.6777 43.8926 97.6302 45.4405 97.5588 46.8214",
    stroke: "black",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6774 43.8922C96.6774 43.8922 97.6299 45.4402 97.5585 46.821C97.6534 46.3448 97.7248 45.8686 97.7248 45.3923C97.7248 43.5353 96.9395 40.6309 94.7246 39.1543C95.9391 40.3688 96.6774 42.0352 96.6774 43.8922Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1309 66.131V59.6074",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1309 66.1309L84.1547 67.6545",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.776 90.5098C61.7762 90.5098 64.2044 92.9379 64.2044 95.9381C64.2044 98.9383 61.7762 101.366 58.776 101.366C55.7758 101.366 53.3477 98.9383 53.3477 95.9381C53.3477 92.9379 55.7758 90.5098 58.776 90.5098Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.776 89.2246C61.7762 89.2246 64.2044 91.6528 64.2044 94.6529C64.2044 97.6531 61.7762 100.081 58.776 100.081C55.7758 100.081 53.3477 97.6531 53.3477 94.6529C53.3477 91.6528 55.7758 89.2246 58.776 89.2246Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9414 99.6055L61.0128 100.676",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7747 90.9141C60.8459 90.9141 62.5123 92.5805 62.5123 94.6517C62.5123 96.6994 60.8459 98.3893 58.7747 98.3893C56.7035 98.3893 55.0371 96.6986 55.0371 94.6517C55.0363 92.5813 56.7035 90.9141 58.7747 90.9141Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6556 97.4375C75.1317 97.4375 73.084 99.4852 73.084 102.009C73.084 104.533 75.1317 106.581 77.6556 106.581C80.1796 106.581 82.2273 104.533 82.2273 102.009C82.2273 99.4852 80.1796 97.4375 77.6556 97.4375Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6556 96.3438C75.1317 96.3438 73.084 98.3915 73.084 100.915C73.084 103.439 75.1317 105.487 77.6556 105.487C80.1796 105.487 82.2273 103.439 82.2273 100.915C82.2273 98.3915 80.1796 96.3438 77.6556 96.3438Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6547 97.7715C75.9169 97.7715 74.5117 99.1758 74.5117 100.914C74.5117 102.652 75.9161 104.057 77.6547 104.057C79.3925 104.057 80.8211 102.653 80.8211 100.914C80.8211 99.1767 79.3933 97.7715 77.6547 97.7715Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8221 53.1549C70.1789 55.5117 74.0358 55.5117 76.3934 53.1549L77.9414 51.607H79.0131C81.9419 51.607 82.6323 50.9166 84.3222 52.2025C86.5362 53.8932 87.0368 56.7741 87.0368 58.8453V67.6308H80.5367H63.8233H57.1804L55.8945 65.7259L57.1804 58.8453C58.1094 53.9411 60.2041 51.6078 65.1798 51.6078H66.275L67.8221 53.1549Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1085 31.2508C74.4183 31.2508 74.9894 30.6318 76.775 31.8219C79.561 33.7025 80.537 37.3452 80.537 39.6785C80.537 44.3215 76.3702 50.0825 71.8473 50.0825C67.3 50.0825 64.0378 44.8918 63.7052 40.3445C63.7052 40.1068 63.6816 39.8918 63.6816 39.6776C63.68 35.0363 67.4655 31.2508 72.1085 31.2508Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M85.75 65.7246L87.0359 67.6295",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M79.25 65.7246L80.5351 67.6295",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8945 65.7246L57.1796 67.6295",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.893 49.7031H64.9648L66.5362 51.2746C68.893 53.6314 72.7499 53.6314 75.1075 51.2746L76.6547 49.7031H77.7264C82.7264 49.7031 85.7501 51.965 85.7501 56.965V65.7261H55.8945V56.965C55.8937 51.965 58.9174 49.7031 63.893 49.7031Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8231 29.3691C66.18 29.3691 62.3945 33.1311 62.3945 37.7733C62.3945 42.4398 66.18 48.4637 70.8231 48.4637C75.4661 48.4637 79.2516 42.4398 79.2516 37.7733C79.2516 33.1311 75.4661 29.3691 70.8231 29.3691Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4189 38.4637C67.4189 38.2974 70.7995 37.9161 74.3473 34.4397C74.3473 34.4397 75.6332 36.8922 79.2516 37.7733C79.2516 33.1303 75.4661 29.3691 70.8231 29.3691C66.18 29.3691 62.3945 33.1311 62.3945 37.7733C62.3945 38.0118 62.3945 38.226 62.4189 38.4637Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M79.25 65.7261V57.5117",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M79.25 37.7734C79.25 37.7734 80.4166 39.7254 80.3452 41.464",
    stroke: "black",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2515 37.7739C79.2515 37.7739 80.4181 39.7259 80.3467 41.4645C80.466 40.8455 80.5374 40.25 80.5374 39.6788C80.5374 37.3455 79.5614 33.7028 76.7754 31.8223C78.299 33.3459 79.2515 35.465 79.2515 37.7739Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2031 65.7261V57.5117",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2031 65.7246L63.4882 67.6295",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6087 69.4883C63.9662 69.4883 59.3945 74.0834 59.3945 79.726C59.3945 85.3685 63.9662 89.9401 69.6087 89.9401C75.2748 89.9401 79.8464 85.3685 79.8464 79.726C79.8464 74.0834 75.2756 69.4883 69.6087 69.4883Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6087 67.082C63.9662 67.082 59.3945 71.6537 59.3945 77.2962C59.3945 82.9387 63.9662 87.5104 69.6087 87.5104C75.2748 87.5104 79.8464 82.9387 79.8464 77.2962C79.8464 71.6537 75.2756 67.082 69.6087 67.082Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5139 86.6523L65.3711 88.6287",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6073 70.25C65.7269 70.25 62.584 73.4165 62.584 77.2977C62.584 81.1781 65.7269 84.3211 69.6073 84.3211C73.5121 84.3211 76.655 81.1781 76.655 77.2977C76.655 73.4165 73.5121 70.25 69.6073 70.25Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2032 72.9395L97.0602 78.9633L103.083 78.7248V80.4869L97.7263 82.3196L95.2032 88.7004L92.6792 82.3196L87.3223 80.4869V78.7248L93.3461 78.9633L95.2032 72.9395Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2032 70.8691L97.0602 76.8922L103.083 78.7257L97.0602 80.5827L95.2032 85.9397L93.3461 80.5827L87.3223 78.7257L93.3461 76.8922L95.2032 70.8691Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6777 82.319V80.4863",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7012 82.3904V80.3906",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2031 88.7012V85.8203",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5854 29.1309L62.1804 34.2736L67.3231 34.083V35.5831L62.7515 37.1545L60.5854 42.5829L58.4427 37.1545L53.8711 35.5831V34.083L59.0139 34.2736L60.5854 29.1309Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5854 27.3457L62.1804 32.5129L67.3231 34.0835L62.1804 35.655L60.5854 40.2266L59.0139 35.655L53.8711 34.0835L59.0139 32.5129L60.5854 27.3457Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4414 37.1554V35.584",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7266 37.2261V35.4883",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M60.584 42.5834V40.1309",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2764 76.2969L45.443 80.1294L49.2999 79.9866V81.1062L45.8714 82.2964L44.2764 86.3439L42.657 82.2964L39.2285 81.1062V79.9866L43.0854 80.1294L44.2764 76.2969Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2764 74.9629L45.443 78.7962L49.2999 79.9864L45.443 81.1774L44.2764 84.5816L43.0854 81.1774L39.2285 79.9864L43.0854 78.7962L44.2764 74.9629Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6562 82.2956V81.1055",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8711 82.3202V81.0352",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2754 86.3433V84.5098",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5371 87.9629V78.7969",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1562 96.3669V93.748",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M79.25 94.7241V90.1289",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4648 63.3216V58.75",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3223 88.439V86.6777",
    stroke: "#171819",
    strokeWidth: 0.4819,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7129,
    y: 23.4141,
    width: 101.574,
    height: 101.574,
    rx: 50.7871,
    fill: "#212327"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7129,
    y: 23.4141,
    width: 101.574,
    height: 101.574,
    rx: 50.7871,
    stroke: "#0B0B0B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7963 44.4616C47.405 44.5409 46.5488 44.8529 45.8939 45.1548C45.2387 45.457 44.6039 45.7234 44.4831 45.7471C44.2303 45.797 43.2844 46.5714 42.5736 47.3102C42.3057 47.5888 41.7475 48.4956 41.3332 49.3254C40.601 50.7924 40.5801 50.8964 40.5801 53.0795C40.5801 55.477 40.7244 56.0073 41.9495 58.1145C42.262 58.6519 42.4563 59.1902 42.3813 59.311C42.3065 59.4318 42.3299 59.4784 42.4335 59.4146C42.6014 59.3112 45.6585 64.4392 45.5164 64.5855C45.4847 64.6179 45.6416 64.844 45.8652 65.088C46.0888 65.3318 46.5919 66.1502 46.9832 66.9068C47.3745 67.6634 47.7766 68.3416 47.8768 68.414C47.9768 68.4863 48.0008 68.6962 47.9298 68.8804C47.8581 69.0671 47.8853 69.1633 47.9916 69.0979C48.2142 68.9609 48.657 69.6871 48.4667 69.877C48.3962 69.9473 48.436 70.0048 48.5555 70.0048C48.8135 70.0048 49.6258 71.3205 49.6258 71.7388C49.6258 71.8996 49.6965 72.0311 49.7829 72.0311C49.8693 72.0311 50.1189 72.3732 50.3378 72.791C50.5565 73.209 51.0804 74.1223 51.502 74.821C51.9234 75.5194 52.2683 76.1369 52.2683 76.193C52.2683 76.2491 52.4913 76.6351 52.7641 77.0505C53.0367 77.4661 53.2883 77.9429 53.3231 78.1101C53.3579 78.2772 53.4418 78.4596 53.5095 78.5153C53.6801 78.6558 55.1493 81.097 55.5825 81.96C55.7782 82.3501 56.0248 82.806 56.1303 82.9732C56.6416 83.7831 57.96 86.0279 57.96 86.0884C57.96 86.1263 58.4302 86.9681 59.0048 87.9593C59.5795 88.9504 60.2525 90.1261 60.5007 90.5719C60.7489 91.0176 61.3839 92.1309 61.9122 93.046C62.4405 93.9608 62.8125 94.8066 62.7389 94.9254C62.6654 95.0439 62.7087 95.116 62.8351 95.0854C62.9615 95.0549 63.2967 95.4401 63.5797 95.9416C63.8626 96.4431 64.2232 97.0554 64.3812 97.3022C64.5389 97.549 64.668 97.8909 64.668 98.0621C64.668 98.2331 64.7402 98.3731 64.8286 98.3731C64.9168 98.3731 65.3512 99.0195 65.7941 99.8098C66.2369 100.6 66.8176 101.633 67.0849 102.107C67.352 102.58 67.8259 103.138 68.1377 103.347C68.4495 103.556 68.6717 103.78 68.6314 103.845C68.5369 103.997 69.5956 104.132 70.7925 104.119C71.9375 104.107 72.7967 103.555 73.4374 102.418C73.6865 101.977 73.9647 101.615 74.056 101.615C74.1473 101.615 74.207 101.547 74.1891 101.463C74.1526 101.294 74.5164 100.463 74.8321 99.9942C74.9447 99.827 75.6621 98.6193 76.4264 97.3107C77.1905 96.0019 77.8908 94.9989 77.9824 95.0818C78.0743 95.1645 78.0782 95.1098 77.9912 94.9598C77.8954 94.7951 78.0032 94.4579 78.2634 94.1067C78.5002 93.7876 78.6939 93.4865 78.6939 93.4377C78.6939 93.3888 79.0681 92.7345 79.5257 91.984C80.5219 90.3494 81.0055 89.5131 81.7934 88.0625C82.8458 86.1249 83.4922 85.19 83.6686 85.3499C83.7633 85.4358 83.7747 85.3914 83.6938 85.2514C83.6125 85.1108 83.7345 84.7339 83.9662 84.4096C84.1969 84.0867 84.3856 83.778 84.3856 83.7239C84.3856 83.6698 85.2088 82.2427 86.215 80.5528C87.2212 78.8628 88.0445 77.411 88.0445 77.3267C88.0445 77.2424 88.2098 76.9966 88.4116 76.7806C88.6135 76.5644 88.8011 76.2965 88.8283 76.1851C88.9745 75.5867 92.0624 70.6304 92.2071 70.7615C92.3013 70.8468 92.3218 70.8176 92.2527 70.6964C92.1836 70.5752 92.4891 69.8585 92.9316 69.1035C93.3741 68.3485 93.7362 67.6987 93.7362 67.6592C93.7362 67.6199 94.2393 66.7605 94.8542 65.7496C95.4691 64.7387 95.9722 63.8765 95.9722 63.8335C95.9722 63.7906 96.4295 63.0204 96.9885 62.1219C97.5475 61.2234 98.0049 60.4496 98.0049 60.4026C98.0049 60.3554 98.4623 59.542 99.0213 58.5953C99.5803 57.6484 100.038 56.7228 100.038 56.538C100.038 56.3532 100.11 56.2464 100.198 56.3005C100.286 56.3548 100.379 55.38 100.404 54.1342C100.445 52.1628 100.386 51.6878 99.9472 50.4678C99.6701 49.6968 99.362 49.0129 99.2628 48.9481C99.1634 48.883 98.9666 48.6117 98.8255 48.3448C98.2803 47.3137 96.8782 46.0509 95.6349 45.4713C92.9397 44.2154 94.0856 44.2685 70.2662 44.2941C58.299 44.3068 48.1876 44.3822 47.7963 44.4616ZM67.1073 69.3933C67.1073 79.6484 67.0703 88.039 67.025 88.039C66.9294 88.039 64.9872 84.7701 64.9483 84.5436C64.9339 84.4599 64.8997 84.3233 64.8727 84.2396C64.8455 84.156 64.8363 84.0125 64.8522 83.9207C64.8682 83.8287 64.8014 83.8028 64.7036 83.8632C64.606 83.9233 64.3989 83.725 64.2434 83.4222C64.0879 83.1195 63.6956 82.416 63.3715 81.8587C61.215 78.1508 59.1796 74.604 59.1796 74.5539C59.1796 74.5215 58.719 73.7545 58.1561 72.8498C57.5858 71.9331 57.1953 71.0962 57.2739 70.9594C57.3518 70.8245 57.3402 70.7819 57.2485 70.8648C57.1566 70.9477 56.9818 70.8399 56.8601 70.6251C56.1517 69.3755 54.7426 66.9283 53.528 64.8378C53.0749 64.0576 52.6747 63.283 52.6387 63.1162C52.6027 62.9494 52.4626 62.7215 52.3275 62.6096C52.1925 62.4978 51.5634 61.4944 50.9296 60.3799C50.2957 59.2654 49.6103 58.08 49.4062 57.7457C48.2425 55.8387 46.9832 53.3841 46.9832 53.0226C46.9832 52.2641 47.3473 51.6321 48.0337 51.1985C48.6964 50.7799 48.9092 50.7703 57.9092 50.7592L67.1073 50.7476V69.3933ZM92.9387 51.7525C93.4386 52.2508 93.5329 52.5073 93.5329 53.3687C93.5329 54.3338 92.9495 55.7794 92.6716 55.5026C92.6086 55.4397 92.571 55.5107 92.5877 55.66C92.6293 56.0308 88.5952 62.9002 88.4047 62.7829C88.3209 62.7312 88.299 62.8102 88.3561 62.9584C88.413 63.1065 88.2291 63.5391 87.9471 63.92C87.6654 64.301 87.4347 64.6757 87.4347 64.7531C87.4347 65.056 85.2594 68.5816 85.1316 68.4857C85.0566 68.4296 85.0375 68.4409 85.0891 68.511C85.1405 68.581 84.9686 69.014 84.7069 69.4735C84.0766 70.5797 82.3916 73.471 82.1534 73.8548C82.0497 74.022 81.26 75.3898 80.3985 76.8943C77.2858 82.3309 76.404 83.7837 76.2174 83.7837C76.1129 83.7837 76.0694 83.852 76.1211 83.9357C76.1727 84.0194 75.9956 84.4524 75.7279 84.8982C75.46 85.344 75.1771 85.8455 75.0988 86.0127C75.0205 86.1798 74.6542 86.8181 74.2849 87.4311L73.6131 88.5455L73.6127 69.8529L73.6121 51.1602H82.9783H92.3445L92.9387 51.7525Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9671,
    y: 14.6175,
    width: 101.066,
    height: 101.066,
    rx: 50.5329,
    fill: "#373C44"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9671,
    y: 14.6175,
    width: 101.066,
    height: 101.066,
    rx: 50.5329,
    stroke: "#0B0B0B",
    strokeWidth: 1.50844
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0424 36.1907C58.9515 36.4095 83.5489 35.2571 83.8782 36.1907C84.1532 37.1242 83.8239 41.5169 82.9989 42.065C80.9129 43.4924 78.9916 44.9198 77.6185 46.2369C79.3209 49.4752 81.8464 53.0447 84.5909 56.6685C89.9713 63.9703 105.344 75.7751 95.0226 88.7865C91.8385 92.7396 87.502 94.8797 82.3946 94.8797H57.4698C52.4187 94.8797 48.026 92.7376 44.898 88.7865C34.5226 75.7751 49.9493 63.9703 55.3297 56.6685C58.0199 53.0447 60.5455 49.4771 62.248 46.2369C60.8748 44.9198 58.9534 43.4924 56.8675 42.065C55.8235 41.3503 55.4943 36.1907 56.0424 36.1907Z",
    fill: "#AE7A00",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.248 42.834H66.0906H69.9332H73.7758H77.6185C79.3209 46.0723 81.8464 49.6419 84.5909 53.2656C89.9713 60.5674 105.344 72.3722 95.0226 85.3836C91.8385 89.3909 87.502 91.4768 82.3946 91.4768C74.1051 91.4768 65.8136 91.4768 57.4698 91.4768C52.4187 91.4768 48.026 89.3909 44.898 85.3836C34.5226 72.3722 49.9493 60.5674 55.3297 53.2656C58.0199 49.6419 60.5455 46.0723 62.248 42.834Z",
    fill: "#FFC949",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2477 42.8354H77.6201C78.9933 41.5183 80.9147 40.0909 83.0006 38.6635C83.8237 38.1154 84.153 37.1257 83.8799 36.1921C83.5507 35.2586 82.7275 34.6543 81.7378 34.6543H58.1301C57.1423 34.6543 56.3192 35.2586 56.0441 36.1921C55.7149 37.1257 56.0441 38.1134 56.8673 38.6635C58.9532 40.089 60.8745 41.5164 62.2477 42.8354Z",
    fill: "#FFC949",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2715 46.2383H71.0866",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8711 46.2383H79.6473",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6016 91.4785V94.8815",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6914 91.4785V94.8815",
    stroke: "#171819",
    strokeWidth: 0.988158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5191 55.6582V55.339H72.1998H68.3671H68.0478V55.6582V59.3544H64.5371H64.2179V59.6736V71.714V72.0333H64.5371H71.8807V75.4043H64.5371H64.2179V75.7235V79.7419V80.0611H64.5371H68.0478V83.7514V84.0706H68.3671H72.1998H72.5191V83.7514V80.0611H76.0298H76.349V79.7419V67.6954V67.3762H76.0298H68.6862V64.0052H76.0298H76.349V63.6859V59.6735V59.3542H76.0298H72.5191V55.6582Z",
    fill: "#595E65",
    stroke: "#0B0B0B",
    strokeWidth: 0.638482
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6283 80.8965C85.3924 80.8965 81.1406 85.1482 81.1406 90.3842C81.1406 95.6202 85.3924 99.8719 90.6283 99.8719C95.8643 99.8719 100.116 95.6202 100.116 90.3842C100.116 85.1482 95.8643 80.8965 90.6283 80.8965Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.632431,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6283 78.6465C85.3924 78.6465 81.1406 82.8982 81.1406 88.1342C81.1406 93.3702 85.3924 97.6219 90.6283 97.6219C95.8643 97.6219 100.116 93.3702 100.116 88.1342C100.116 82.8982 95.8643 78.6465 90.6283 78.6465Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 0.632431,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.6096 82.125H89.6424C89.045 82.125 88.5528 82.6171 88.5528 83.2146V86.0607H85.7068C85.1093 86.0607 84.6172 86.5528 84.6172 87.1502V89.1174C84.6172 89.7149 85.1093 90.207 85.7068 90.207H88.5528V93.0531C88.5528 93.6506 89.045 94.1427 89.6424 94.1427H91.6096C92.2071 94.1427 92.6992 93.6506 92.6992 93.0531V90.207H95.5453C96.1428 90.207 96.6349 89.7149 96.6349 89.1174V87.1502C96.6349 86.5528 96.1428 86.0607 95.5453 86.0607H92.6992V83.2146C92.6992 82.6171 92.2071 82.125 91.6096 82.125Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.632431,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8334 96.8125L86.6934 98.6743",
    stroke: "#171819",
    strokeWidth: 0.632431,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7129,
    y: 14.3633,
    width: 101.574,
    height: 101.574,
    rx: 50.7871,
    fill: "#373C44"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7129,
    y: 14.3633,
    width: 101.574,
    height: 101.574,
    rx: 50.7871,
    stroke: "#0B0B0B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5769 81.8046L47.5746 81.803C46.6182 81.1547 45.7238 80.0863 45.0679 78.8786C44.4112 77.6695 44.0215 76.3727 44.0215 75.2913V51.5211C44.0215 49.996 44.6571 48.3604 45.7189 46.9546C46.7792 45.5508 48.2359 44.4148 49.8231 43.8649C49.8233 43.8648 49.8235 43.8648 49.8236 43.8647L67.4044 37.8206C67.4048 37.8205 67.4052 37.8204 67.4056 37.8202C68.2491 37.5352 69.3895 37.3848 70.5533 37.3848C71.7171 37.3848 72.8576 37.5352 73.7011 37.8202C73.7014 37.8204 73.7018 37.8205 73.7022 37.8206L91.2816 43.8642C91.282 43.8644 91.2825 43.8645 91.2829 43.8647C92.8538 44.4143 94.3024 45.5498 95.3548 46.9533C96.4087 48.3588 97.0359 49.993 97.0212 51.5162V51.5211V75.2913C97.0212 76.3723 96.6318 77.6615 95.9751 78.8671C95.3195 80.0705 94.4244 81.1411 93.4646 81.8054C93.4644 81.8055 93.4642 81.8056 93.4641 81.8057L75.8815 93.8657L75.8801 93.8667C74.4297 94.8686 72.4884 95.3848 70.5213 95.3848C68.5543 95.3848 66.613 94.8686 65.1626 93.8667L65.1612 93.8658L47.5769 81.8046ZM64.1863 72.811L64.1886 72.8131C64.7693 73.3461 65.5011 73.5903 66.2212 73.5903C66.9413 73.5903 67.6731 73.3461 68.2538 72.8131L81.9986 60.197C83.1771 59.1479 83.1768 57.367 82.0335 56.3176C81.4947 55.8231 80.6017 55.3772 79.7282 55.1616C79.2866 55.0527 78.8238 54.9958 78.3914 55.0331C77.9606 55.0703 77.5226 55.205 77.1834 55.5164L77.1833 55.5163L77.1752 55.5241L65.0286 67.1848L62.375 64.5312L62.3675 64.5236L62.3596 64.5164C61.8849 64.0807 61.3748 63.7052 60.8055 63.6021C60.1867 63.4901 59.6144 63.7149 59.0732 64.2116C57.9305 65.2605 57.9301 67.0087 59.0721 68.058C59.0724 68.0584 59.0728 68.0587 59.0732 68.059L64.1863 72.811Z",
    fill: "#AE7A00",
    stroke: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2939 80.3481L46.2917 80.3464C45.4107 79.6958 44.5822 78.6194 43.9729 77.3974C43.3638 76.1757 43 74.8607 43 73.7593V49.7707C43 48.2189 43.5934 46.5616 44.5768 45.1431C45.56 43.7249 46.9055 42.5851 48.3621 42.0353C48.3623 42.0352 48.3625 42.0351 48.3627 42.035L64.6476 35.9356C64.648 35.9355 64.6484 35.9353 64.6487 35.9352C65.4206 35.6511 66.4679 35.5 67.5399 35.5C68.6119 35.5 69.6592 35.6511 70.4311 35.9352C70.4315 35.9353 70.4319 35.9355 70.4323 35.9356L86.7157 42.0345C86.7162 42.0347 86.7166 42.0348 86.7171 42.035C88.1586 42.5846 89.4966 43.7239 90.4725 45.1418C91.4487 46.5601 92.0344 48.2161 92.0206 49.7663V49.7707V73.7593C92.0206 74.8603 91.657 76.1677 91.048 77.3857C90.4392 78.6033 89.6101 79.6818 88.7258 80.3487C88.7256 80.3489 88.7253 80.3491 88.725 80.3493L72.4382 92.52L72.4368 92.5211C71.1021 93.5255 69.3176 94.042 67.5103 94.042C65.703 94.042 63.9185 93.5255 62.5838 92.5211L62.5825 92.52L46.2939 80.3481ZM74.3681 54.6295L63.5566 65.441L60.7117 62.5961C59.6576 61.542 57.9195 61.542 56.8654 62.5961C55.8116 63.6498 55.8113 65.3871 56.8643 66.4414C56.8646 66.4417 56.865 66.4421 56.8654 66.4425L61.6017 71.238L61.6038 71.2402C62.1468 71.7831 62.8389 72.0382 63.527 72.0382C64.2152 72.0382 64.9073 71.7831 65.4502 71.2402L78.1821 58.5083C79.2696 57.4535 79.2685 55.6835 78.2145 54.6295C77.1604 53.5754 75.4223 53.5754 74.3681 54.6295Z",
    fill: "#FFC949",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassKeySetUpCircle);
export default __webpack_public_path__ + "static/media/pass-key-set-up-circle.d75761b668cc2628d7c7f9c78fb8f835.svg";
export { ForwardRef as ReactComponent };